// extracted by mini-css-extract-plugin
export default {"title":"Features_title__TBGuy","list":"Features_list__SqnlO","item":"Features_item__Pre+j"};